var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["container"] = pug_interp = function(className){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["container",className], [false,true])},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["sliderButtons"] = pug_interp = function(className, isCount, isSmall, isHide){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["sliderButtons",className], [false,true]), false, true)) + "\u003E";
if (isCount) {
pug_html = pug_html + "\u003Cdiv class=\"sliderButtons__counter\"\u003E\u003Cspan data-name=\"activeSlide\"\u003E1\u003C\u002Fspan\u003E\u002F\u003Cspan data-name=\"slidesLength\"\u003E15\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (!isHide) {
pug_html = pug_html + "\u003Cbutton class=\"sliderButtons__btn sliderButtons__btn--prev\"\u003E\u003Csvg version=\"1.1\" id=\"Слой_1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\"\u003E\n\u003Cpath d=\"M15,18.8c-0.2,0-0.4-0.1-0.5-0.2l-6-6c-0.3-0.3-0.3-0.8,0-1.1l6-6c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1L10.1,12\n\tl5.5,5.5c0.3,0.3,0.3,0.8,0,1.1C15.4,18.7,15.2,18.8,15,18.8z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n\u003C\u002Fbutton\u003E\u003Cbutton class=\"sliderButtons__btn sliderButtons__btn--next\"\u003E\u003Csvg version=\"1.1\" id=\"Слой_1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24;\" xml:space=\"preserve\"\u003E\n\u003Cpath d=\"M9,18.8c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l5.5-5.5L8.5,6.5c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0\n\tl6,6c0.3,0.3,0.3,0.8,0,1.1l-6,6C9.4,18.7,9.2,18.8,9,18.8z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};




pug_mixins["input"] = pug_interp = function(type, id, name, className, error, inputClass, vueClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["input",className], [false,true]), false, true)+pug.attr(":class", (vueClass || false), true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"input__field\"\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([inputClass], [true]),"type": pug.escape(type),"id": pug.escape(id),"name": pug.escape(name),"autocomplete": "off"},attributes]), true)) + "\u003E\u003C\u002Fdiv\u003E";
if ((error)) {
pug_html = pug_html + "\u003Cdiv class=\"input__error-text\"\u003E" + (null == (pug_interp = error) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};






























































pug_html = pug_html + "\u003Cdiv class=\"popup-fullscreen\" @click.self=\"closePopup\"\u003E";
pug_mixins["container"].call({
block: function(){
pug_html = pug_html + "\u003Cbutton class=\"popup-fullscreen__close\" @click=\"closePopup\"\u003E\u003Csvg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M2 2L26 26\" stroke-width=\"3\"\u002F\u003E\n\u003Cpath d=\"M26 2L2 26\" stroke-width=\"3\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n\u003C\u002Fbutton\u003E\u003Cdiv class=\"popup-fullscreen__slider swiper-container\" ref=\"fullSlider\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E\u003Cdiv class=\"swiper-slide popup-fullscreen__slide\" v-for=\"(card, i) in mediaArray\" :key=\"card.id\"\u003E\u003Cimg class=\"card-popup__main-slide-img swiper-lazy\" :src=\"card.img ? card.img : card\" alt=\"\"\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-text\" v-if=\"card.text\"\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-title\"\u003E${ card.text.title }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-description\"\u003E${ card.text.description }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["sliderButtons"]('popup-fullscreen__slider-btns sliderButtons--transparent', true, false, true);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__btns-nav\"\u003E\u003Cdiv class=\"popup-fullscreen__btn popup-fullscreen__btn--prev\"\u003E\u003Csvg viewBox=\"0 0 10 18\" fill=\"#1A1A1A\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.39726 0L0 1.46179L7.20548 9L0 16.5382L1.39726 18L10 9L1.39726 0Z\"\u002F\u003E\u003C\u002Fsvg\u003E\n${ fullscreenbuttontext[0] || 'Предыдущее' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__btn popup-fullscreen__btn--next\"\u003E${ fullscreenbuttontext[1] || 'Следующее' }}\u003Csvg viewBox=\"0 0 10 18\" fill=\"#1A1A1A\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.39726 0L0 1.46179L7.20548 9L0 16.5382L1.39726 18L10 9L1.39726 0Z\"\u002F\u003E\u003C\u002Fsvg\u003E\n\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'popup-fullscreen__container');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./new-blocks/popup/fullscreen/popup-fullscreen.pug
// module id = ./new-blocks/popup/fullscreen/popup-fullscreen.pug
// module chunks = 1